<template>
  <div class="marker_paginator">
    <b-button id="prev" v-on:click="$emit('prev')" v-bind:disabled="first_page" > &lt; </b-button>
    <b-button id="next" v-on:click="$emit('next')" v-bind:disabled="last_page"  > &gt; </b-button>
  </div>
</template>

<script>
// FIXME: disabled functionality not working

export default {
  name: 'MarkerPaginator',

  props : {
    markers : Array,
    page : Number
  },

  computed : {
    first_page : function(){
      return this.page == 0;
    },

    last_page : function(){
      return this.markers[this.page] == null;
    }
  }
}
</script>

<style scoped>
.marker_paginator{
  width: 100px;
  margin: auto;
}

#prev, #next{
  margin: 5px;
}
</style>
